<template>
    <GhostBtn class="SortBtn" @click="$emit('click')" ref="buttonRef">
        Sort <i class="lnr-sorting Icon"></i>
    </GhostBtn>
</template>

<script lang="ts" setup>
import GhostBtn from '@components/GhostBtn/GhostBtn.vue';
import { ref, onMounted, onUnmounted } from 'vue';

const emits = defineEmits(['click', 'clickOutside']);
const buttonRef = ref<InstanceType<typeof GhostBtn> | null>(null);

const handleClickOutside = (event: MouseEvent) => {
    if (buttonRef.value && buttonRef.value.$el) {
        const target = event.target as Node;
        if (!buttonRef.value.$el.contains(target)) {
            emits('clickOutside');
        }
    }
};

onMounted(() => {
    setTimeout(() => {
        document.addEventListener('click', handleClickOutside);
    }, 0);
});

onUnmounted(() => {
    document.removeEventListener('click', handleClickOutside);
});
</script>

<style scoped lang="scss">
.SortBtn {
    color: $Blue-700;
    @include TextStyle(UiMediumSemibold);

    .Icon {
        font-size: 1rem;
    }
}
</style>